module.exports = __webpack_public_path__ + "img/1535252100.68fd5362.jpg";